import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';
import { SupplierSpecialOffer } from '../../models/supplier-special-offer';

export const SUPPLIER_SPECIAL_OFFERS_LIST_FETCH = 'SUPPLIER_SPECIAL_OFFERS_LIST_FETCH';
export const SUPPLIER_SPECIAL_OFFERS_LIST_RECEIVE = 'SUPPLIER_SPECIAL_OFFERS_LIST_RECEIVE';
export const SUPPLIER_SPECIAL_OFFERS_LIST_ERROR = 'SUPPLIER_SPECIAL_OFFERS_LIST_ERROR';

export const receiveSupplierSpecialOffersList = (supplierSpecialOffers: PaginatedResponse<SupplierSpecialOffer>) => {
    return {
        type: SUPPLIER_SPECIAL_OFFERS_LIST_RECEIVE,
        supplierSpecialOffers,
    };
};

const supplierSpecialOffersListError = () => {
    return {
        type: SUPPLIER_SPECIAL_OFFERS_LIST_ERROR,
    };
};

export const fetchSupplierSpecialOffersList = (searchParams: URLSearchParams = new URLSearchParams()) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SUPPLIER_SPECIAL_OFFERS_LIST_FETCH });
        const response = await api.contentManagement.SupplierSpecialOffers.List.getSupplierSpecialOffers(searchParams);
        if (response.success) {
            dispatch(receiveSupplierSpecialOffersList(response.result));
        } else {
            dispatch(supplierSpecialOffersListError());
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
